// extracted by mini-css-extract-plugin
module.exports = {"extra":"MonthlyBreakdown_extra__3f9uK","title":"MonthlyBreakdown_title__R_ZXQ"};